<p-dialog class="prime-dialog" [styleClass]="classes()" [visible]="visible()" [header]="header()" [modal]="modal()" [position]="position()"
  [draggable]="draggable()" [closeOnEscape]="closeOnEscape()" [closable]="closable()" [maximizable]="maxizable()"
  [resizable]="resizable()" [breakpoints]="breakpoints()" [style]="style()" (visibleChange)="handleCloseButton()">
  @if (headerRef()) {
  <ng-template pTemplate="header">
    <ng-content select="[dialog-title]"></ng-content>
  </ng-template>
  }
  <ng-content select="[dialog-body]"></ng-content>
</p-dialog>
